import api from "@/config/apiConfig"

class TemplateController {

  async index () {
    try {
      const response = await api.get("/template");
      return response.data;
    } catch ( error ) {
      console.error( "Erro no TemplateController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/template`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no TemplateController.create: ", error );
      throw error;
    }
  }
}

export default new TemplateController();